import { render, staticRenderFns } from "./ProductRegistrationConfirmation.vue?vue&type=template&id=3b403818&"
import script from "./ProductRegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./ProductRegistrationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports